import { ChangeDetectionStrategy, Component, computed, input, output } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { PluralizadorPipe } from '@aionzdev/design-system';

@Component({
  selector: 'aionz-purchase-batch-action-bar',
  imports: [MatButtonModule, MatIconModule, PluralizadorPipe],
  templateUrl: './purchase-batch-action-bar.component.html',
  styleUrl: './purchase-batch-action-bar.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class PurchaseBatchActionBarComponent {
  public selectedCount = input<number>(0);

  public approve = output<void>();
  public decline = output<void>();
  public clearSelection = output<void>();

  protected isVisible = computed(() => this.selectedCount() > 0);
}
